import type { RouteRecordRaw, Router } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'

import IncidentTable from '@/components/Dashboard/IncidentTable.vue'
import BookmarkList from '@/views/bookmarks/BookmarkList.vue'
import BookmarkNew from '@/views/bookmarks/BookmarkNew.vue'
import EmptyComponent from '@/views/EmptyComponent.vue'
import IncidentList from '@/views/incidents/IncidentList.vue'
import IncidentNew from '@/views/incidents/IncidentNew.vue'
import LayersList from '@/views/layers/LayerList.vue'
import Print from '@/views/print/PrintTab.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'default',
    component: EmptyComponent
  },
  {
    path: '/incidents/',
    name: 'incidentlist',
    component: IncidentList,
    meta: {
      menuName: 'domain.entities.incidents',
      menuIcon: 'mdi-fire'
    }
  },
  {
    path: '/incidents/new',
    name: 'incidentnew',
    component: IncidentNew
  },
  {
    path: '/layers/',
    name: 'layers',
    component: LayersList,
    meta: {
      menuName: 'domain.entities.layers',
      menuIcon: 'mdi-layers'
    }
  },
  {
    path: '/bookmarks/',
    name: 'bookmarks',
    component: BookmarkList,
    meta: {
      menuName: 'domain.entities.bookmarks',
      menuIcon: 'mdi-bookmark',
      permission: 'bookmarks'
    }
  },
  {
    path: '/bookmarks/new',
    name: 'newbookmarks',
    component: BookmarkNew
  },
  {
    path: '/print/',
    name: 'print',
    component: Print,
    meta: {
      menuName: 'common.actions.print',
      menuIcon: 'mdi-printer'
    }
  },
  {
    path: '/dashboard/',
    name: 'dashboard',
    component: IncidentTable,
    meta: {
      menuName: 'common.concepts.dashboard',
      menuIcon: 'mdi-chart-box',
      fullPage: true,
      permission: 'dashboard'
    }
  }
]

const router: Router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

const AUTH0_CALLBACK_PARAMS = ['code', 'state', 'error', 'error_description']

router.beforeEach((to, from) => {
  const toQueryItems = Object.keys(to.query).length
  const filteredFromQuery = Object.fromEntries(Object.entries(from.query).filter(([k]) => !AUTH0_CALLBACK_PARAMS.includes(k)))
  const fromQueryItems = Object.keys(filteredFromQuery).length
  if (to.name !== from.name && toQueryItems === 0 && fromQueryItems > 0) {
    return {
      ...to,
      query: filteredFromQuery
    }
  }
})

export default router
